// PO-3531: Customer-facing countdown label formatter shared across PDP, Cart,
// and Checkout. Returns the X portion of "Order in the next X" — callers
// supply the surrounding copy. Returns null when no countdown should render
// (already elapsed, week-or-more remaining, or invalid input) so consumers
// can fall back to the legacy static label without branching on string magic.

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * 60;
const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
const SECONDS_PER_WEEK = 7 * SECONDS_PER_DAY;

export const SUB_MINUTE_LABEL = "Less than 1 minute left";

export function formatCountdownLabel(secondsRemaining: number | null | undefined): string | null {
  if (secondsRemaining == null || !Number.isFinite(secondsRemaining)) return null;
  if (secondsRemaining <= 0) return null;
  if (secondsRemaining >= SECONDS_PER_WEEK) return null;
  if (secondsRemaining < SECONDS_PER_MINUTE) return SUB_MINUTE_LABEL;

  if (secondsRemaining < SECONDS_PER_HOUR) {
    const minutes = Math.floor(secondsRemaining / SECONDS_PER_MINUTE);
    return `${minutes}m`;
  }

  if (secondsRemaining < SECONDS_PER_DAY) {
    const hours = Math.floor(secondsRemaining / SECONDS_PER_HOUR);
    const minutes = Math.floor((secondsRemaining % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
    return `${hours}h ${minutes}m`;
  }

  const days = Math.floor(secondsRemaining / SECONDS_PER_DAY);
  const hours = Math.floor((secondsRemaining % SECONDS_PER_DAY) / SECONDS_PER_HOUR);
  return `${days}d ${hours}h`;
}
